module.exports = __webpack_public_path__ + "static/media/image5.1b03cfe4.jpg";